import React, { useEffect, useState } from "react";
import { Button } from "antd";
import { useHistory, useLocation } from "react-router-dom";
import "./style.css";
import { CheckIcon, CopyIcon, LikeIcon } from "assets/svg/icon";
import { useDispatch, useSelector } from "react-redux";
import { checkOrder } from "redux/actions";
import { APP_PREFIX_PATH } from "configs/AppConfig";
import FailedPayment from "./filedPaymend";
import { clearLocalStorgeCart } from "utils/cart";

const CheckOutFive = () => {
    const { fetchedData: {checkedOrderData, storeData} } = useSelector(state => state)
    const history = useHistory();
    const dispatch = useDispatch();
    const [copy, setCopy] = useState(false);

    const search = useLocation().search;
    const orderId = new URLSearchParams(search).get('orderId');
    const orderStatus = new URLSearchParams(search).get('orderStatus');
    const phone = new URLSearchParams(search).get('phone');


    useEffect(()=>{
        orderId && dispatch(checkOrder(orderId))
    }, []);

    const viewReceipt = () => {
        orderId ? history.push(`${APP_PREFIX_PATH}/checkOutFour?orderId=${orderId}`) :
        history.push(`${APP_PREFIX_PATH}/checkOutFour?code=${orderStatus}&phone=${phone}`);
    }

    const CopyCode = () => {
        // navigator.clipboard?.writeText &&
        // navigator.clipboard.writeText(orderStatus);

        const textArea = document.createElement('textarea');
        textArea.style.position = "absolute";
        textArea.style.top = "" + ((document.documentElement && document.documentElement.scrollTop) ||  document.body.scrollTop) + "px";
        textArea.style.left = "-100%";
        textArea.textContent = orderStatus.trim();
        document.body.appendChild(textArea);
        textArea.select();
        document.execCommand("copy");
        textArea.parentNode.removeChild(textArea);

        setCopy(true);
        setTimeout(() => {
            setCopy(false);
        }, 1500);
    };

    useEffect(() => {
        if (checkedOrderData?.status!=='CANCELLED') {
            clearLocalStorgeCart();
            localStorage.removeItem('applied-voucher');
        }
    }, []);

    if (checkedOrderData?.status==='CANCELLED'){
        return <>
            <FailedPayment/>
        </>
    }

    
    return (
        <>
            <div className="checkOut-page-style">
                <div className="mt-2 p-4 h-100">
                    <div className={"text-center"}>
                        {LikeIcon('', 'var(--primaryColor)')}                    
                        <h2 className={'mt-2'}> Thank You! </h2>
                    </div>
                    <div className="text-center rounded mt-4 position-relative" style={{border: "1px solid grey", fontSize: "18px", padding: '5px 0'}}>
                        <span> Order Code: </span> <span style={{color:'black', textDecoration:'underline'}}> {orderId ? checkedOrderData?.orderId : orderStatus} </span>
                        <span onClick={CopyCode} className='position-absolute' style={{top: '22%', right: '10px', cursor: 'pointer'}}>
                            {copy ? CheckIcon(24) : CopyIcon(19)}
                        </span>
                    </div>
                    <div className="mt-5">
                        <div className="d-flex justify-content-between">
                            <h4> Estimated Time </h4>
                            <h4> 45m </h4>
                        </div>
                        <div className="d-flex justify-content-between">
                            <span style={{height: "3px", width: "31%", backgroundColor: "var(--primaryColor)"}}/>
                            <span style={{height: "3px", width: "31%", backgroundColor: "grey"}}/>
                            <span style={{height: "3px", width: "31%", backgroundColor: "grey"}}/>
                        </div>
                    </div>
                    <div>
                        <h3 className="mt-4 mb-4 pl-3 text-muted font-weight-light"> Your order is coming </h3>
                        <Button block className="mb-2 text-black" onClick={()=> viewReceipt()}> View Receipt </Button>
                        <Button block> 
                            <a href={"tel:"+storeData?.supportPhone} className="w-100 h-100 text-black flex-block">
                                Get Help
                            </a> 
                        </Button>
                    </div>
                </div>
                <div className='orderCheckoutContainer branch-btn'>
                    <Button onClick={() => history.push('menu')} className={`w-100 orderCheckout btn-project primaryColor`}>
                        Start Over
                    </Button>
                </div>
            </div>
        </>
    )
}

export default CheckOutFive;